import { Heart } from "lucide-react";

export const Footer = () => (
  <footer
    data-testid="footer"
    className="px-5 sm:px-8 pb-24 pt-6 max-w-3xl mx-auto"
  >
    <div className="ss-rule mb-6" data-testid="footer-rule">
      <span>One more thing</span>
    </div>
    <div
      className="ss-panel p-5 sm:p-6 flex gap-4 items-start"
      data-testid="footer-disclaimer"
      style={{ borderLeft: "3px solid var(--ss-gold)" }}
    >
      <Heart
        className="flex-shrink-0 w-6 h-6 mt-1"
        strokeWidth={2.25}
        color="var(--ss-gold)"
        aria-hidden
      />
      <p
        className="text-base leading-relaxed"
        style={{ color: "var(--ss-ink-2)" }}
      >
        <strong style={{ color: "var(--ss-ink)" }}>
          Wingman reads patterns, not minds.
        </strong>{" "}
        Use it to sharpen your instincts, not replace them. Don&rsquo;t send
        money, gift cards, crypto, banking details, your home address, or
        private photos to anyone you haven&rsquo;t verified in person.
      </p>
    </div>
    <p
      className="mt-6 text-sm text-center"
      style={{ color: "var(--ss-muted)" }}
      data-testid="footer-tag"
    >
      Stay on the app &middot; Ask for a video call &middot; Verify before
      you trust
    </p>
  </footer>
);
